// extracted by mini-css-extract-plugin
module.exports = {"button":"ErrorsButton_button__2umlB"};